import styled from "@emotion/styled";

export const InfoWindowBody = styled.div`
  background: white;
  padding: 15px;
`;
